import api from '~/services/api';
import axios from 'axios';

export class PrinterService {
  constructor(apiClient = api, axiosClient = axios) {
    this.api = apiClient;
    this.axios = axiosClient;
  }

  async getProducts(printerId) {
    if (!printerId) {
      throw new Error('Printer ID is required');
    }

    const response = await this.api.get(
      `/restaurants/printers/${printerId}/products`
    );
    return response.data.categories || [];
  }

  async getWaiters() {
    const response = await this.api.get('/restaurants/waiters');
    return response.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  }

  async getPrinterNames(token) {
    if (!token) {
      throw new Error('Authentication token is required');
    }
    const response = await this.axios.get(
      'https://backend-pdv.takeat.app/restaurants/printers/names',
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (
      !response.data.printerNames ||
      response.data.printerNames.length === 0
    ) {
      throw new Error('Nenhum nome de impressora encontrado.');
    }
    return response.data.printerNames.map((printer) => ({
      label: printer,
      value: printer,
    }));
  }

  async createPrinter(printerData) {
    const response = await this.api.post('/restaurants/printers', printerData);
    return response.data;
  }

  async updatePrinter(printerId, printerData) {
    if (!printerId) {
      throw new Error('Printer ID is required');
    }
    const response = await this.api.put(
      `/restaurants/printers/${printerId}`,
      printerData
    );
    return response.data;
  }

  async deletePrinter(printerId) {
    if (!printerId) {
      throw new Error('Printer ID is required');
    }
    await this.api.delete(`/restaurants/printers/${printerId}`);
  }
}

export const printerService = new PrinterService();
